import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { store } from './store/index';
import { Provider } from 'react-redux';

import './styles/index.css';
import HomePage from './pages/home-page/home-page';
import ErrorPage from './pages/error-page/error-page';

import { pathHome } from './path';

import './firebase';
import AddMenuPage from './pages/add-menu-page/add-menu-page';
import IndexPage from './pages/index-page/index-page';
import GroupHomePage from './pages/group-home-page/group-home-page';
import MenuPage from './pages/menu-page/menu-paje';
import ClientsPage from './pages/clients-page/clients-page';
import ClientInfoPage from './pages/client-info-page/client-info-paje';
import GroupParticipantsPage from './pages/group-participants-page/group-participants-page';
import GroupAddParticipantsPage from './pages/group-add-participants-page/group-add-participants-page';
import StatisticsPage from './pages/statistics-page/statistics-page';
import ControlPage from './pages/control-page/control-page';
import TipsPage from './pages/tips-page/tips-page';
import ContactsPage from './pages/contacts-page/contacts-page';
import UsersActivityPage from './pages/users-activity-page/users-activity-page';
import UserActivityPage from './pages/user-activity-page/user-activity-page';
import LoginPage from './pages/login-page/login-page';
import GroupActivityPage from './pages/group-activit-page/group-activity-page';
import IngredientsPage from './pages/ingredients-page/ingredients-page';
import ProductsPage from './pages/products-page/products-page';
import SitePage from './pages/site-page/site-page';
import DownloadingFilesPage from './pages/downloading-files-page/downloading-files-page';
import ClientApplicationSettingsPage from './pages/client-application-settings-page/client-application-settings-page';

const router = createBrowserRouter([
  {
    path: `/${pathHome}`,
    element: <IndexPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: `/${pathHome}`,
        element: <LoginPage />,
      },
      {
        path: `home`,
        element: <HomePage />,
      },
      {
        path: `tips`,
        element: <TipsPage />,
      },
      {
        path: `usersActivity`,
        element: <UsersActivityPage />,
      },
      {
        path: `userActivity/:user_id`,
        element: <UserActivityPage />,
      },
      {
        path: `contacts`,
        element: <ContactsPage />,
      },
      {
        path: `site`,
        element: <SitePage />,
      },
      {
        path: `downloadingFiles`,
        element: <DownloadingFilesPage />,
      },
      {
        path: `clientApplicationSettings`,
        element: <ClientApplicationSettingsPage />,
      },
      {
        path: 'group/:group_id',
        element: <GroupHomePage />,
      },
      {
        path: 'menu/:group_id',
        element: <MenuPage />,
      },
      {
        path: 'addMenu/:group_id',
        element: <AddMenuPage />,
      },
      {
        path: 'ingredients',
        element: <IngredientsPage />,
      },
      {
        path: 'products',
        element: <ProductsPage />,
      },
      {
        path: 'clients',
        element: <ClientsPage />,
      },
      {
        path: 'client-info/:clientId',
        element: <ClientInfoPage />,
      },
      {
        path: 'participants/:group_id',
        element: <GroupParticipantsPage />,
      },
      {
        path: 'addParticipants/:group_id',
        element: <GroupAddParticipantsPage />,
      },
      {
        path: 'control/:group_id',
        element: <ControlPage />,
      },
      {
        path: 'group-activity/:group_id',
        element: <GroupActivityPage />,
      },
      {
        path: 'statistics/:group_id',
        element: <StatisticsPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
